/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function OlistIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "olist", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M10 7.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 12.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 17.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5 18.5H7.5L7 17.5L7.5 16.5H5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5 8.5H6.5M8 8.5H6.5M5 6.5H6.5V8.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8 13.5H6L7 11.5H5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(OlistIcon);
export default ForwardRef;
//# sourceMappingURL=olistIcon.js.map